import { FaLaptopCode, FaMobileAlt, FaChartLine } from 'react-icons/fa';
import trackateImg from '../assets/TRACKATE.png';
import rescaleImg from '../assets/rescale.png';
import snackateImg from '../assets/snackate.png';
import chatSystemImg from '../assets/chatsystem.png';
import itsaImg from '../assets/itsa.png';
import haircutImg from '../assets/haircut.png';
import spinmealImg from '../assets/spinmeal_logo.png';

// Portfolio/Past Projects Data
export const portfolioData = [
  {
    title: 'Trackate - Smart Finance Manager',
    category: 'App Solution',
    image: trackateImg,
    problem: 'People struggle to manage their personal finances, track shared expenses with friends, and maintain budgets effectively without a simple, intuitive solution.',
    solution: 'Developed Trackate, a comprehensive finance management app with smart expense tracking, AI-powered insights, automated bill splitting, budget management, and intelligent reminders to help users take control of their finances.',
    results: [
      'Thousands of users managing finances smarter',
      'AI-powered automatic expense categorization',
      'Effortless bill splitting with friends and groups',
      'Real-time budget monitoring and analytics',
      'Smart notifications for pending debts and payments'
    ],
    techStack: ['Flutter', 'React JS', 'AI/ML', 'Firebase', 'Node.js'],
    liveLink: 'https://trackate.svnate.com/',
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.svnate.trackate&hl=en_IN',
    icon: '💰',
    gradient: 'from-svnate-teal/20 to-svnate-blue/20'
  },
  {
    title: 'SpinMeal - Meal Decision App',
    category: 'Multi-Platform App',
    image: spinmealImg,
    problem: 'People face daily decision fatigue when choosing what to eat, wasting time and mental energy debating meal options without a quick, personalised way to decide.',
    solution: 'Built SpinMeal — a smart meal randomiser available on Web, Android, and iOS. Users build their personal food list and spin a weighted wheel for an instant meal recommendation, with real-time Firestore sync keeping all platforms perfectly in sync.',
    results: [
      '10K+ meals spun by users',
      '500+ happy users on the platform',
      '99% decision rate — never stuck again',
      'Weighted algorithm ensures zero boring repeats',
      '365-day meal history to spot patterns & favourites',
      'Under 1-second decision time with zero latency'
    ],
    techStack: ['Web App', 'Android', 'iOS', 'React', 'Firebase', 'Firestore'],
    liveLink: 'https://spinmeal.svnate.com/',
    icon: '🍽️',
    gradient: 'from-orange-500/20 to-red-500/20'
  },
  {
    title: 'Snackate - Online Snacks E-Commerce',
    category: 'Web Solution',
    image: snackateImg,
    problem: 'A snacks company needed a modern e-commerce platform to sell their products online, manage inventory, and provide customers with seamless shopping experience including wishlist, cart management, and flexible payment options.',
    solution: 'Developed a complete WooCommerce-based e-commerce website with product catalog, shopping cart, wishlist functionality, secure payment gateway integration (UPI/Credit/Debit), order management, and customer account system with 24/7 online support.',
    results: [
      'Free shipping on all orders',
      'Flexible payment options (UPI/Cards)',
      '24/7 online customer support',
      'New arrivals and exclusive deals platform',
      'Complete order tracking and refund system'
    ],
    techStack: ['WordPress', 'WooCommerce', 'Payment Gateway', 'PHP', 'MySQL'],
    liveLink: 'https://snackate.com/',
    icon: '🍿',
    gradient: 'from-purple-500/20 to-pink-500/20'
  },
  {
    title: 'Rescale India Foundation - NGO Website',
    category: 'Web Solution',
    image: rescaleImg,
    problem: 'A youth-led non-profit organization needed a comprehensive digital platform to showcase their mission, engage volunteers, facilitate donations, and reach underprivileged communities they serve through education and empowerment programs.',
    solution: 'Built a complete NGO website with volunteer registration, donation management, program showcases, gallery, annual reports, and awareness initiatives. Integrated secure payment systems and volunteer management features to streamline operations.',
    results: [
      '3+ years of successful operations',
      '25+ volunteers actively engaged',
      '10+ community projects completed',
      '2,500+ beneficiaries impacted',
      'Focus on SDG 4, 8, 9, 10, 16 (UN Goals)'
    ],
    techStack: ['WordPress', 'PHP', 'MySQL', 'Payment Gateway', 'Responsive Design'],
    liveLink: 'https://rescaleindiafoundation.org/',
    icon: '🤝',
    gradient: 'from-svnate-blue/20 to-green-500/20'
  },
  {
    title: 'Chat System - Real-Time Messaging Platform',
    category: 'Web Solution',
    image: chatSystemImg,
    problem: 'Users needed a secure, real-time chat application with modern authentication methods to communicate instantly with friends, colleagues, and communities without compromising privacy and data security.',
    solution: 'Built a comprehensive real-time chat system with Google OAuth authentication, instant messaging, user status tracking, message history, and secure data encryption. Features include responsive design, password recovery, and seamless user experience across devices.',
    results: [
      'Real-time instant messaging',
      'Secure Google OAuth integration',
      'End-to-end message encryption',
      'User online/offline status tracking',
      'Complete message history & search',
      'Password recovery system'
    ],
    techStack: ['React', 'Firebase', 'Google OAuth', 'Real-time Database', 'Material-UI'],
    liveLink: 'https://chat-system-gs.netlify.app/',
    icon: '💬',
    gradient: 'from-blue-500/20 to-indigo-500/20'
  },
  {
    title: 'ITSA - Student Association Platform',
    category: 'Web Solution',
    image: itsaImg,
    problem: 'AISSMS Institute of Information Technology needed a comprehensive digital platform to manage their student association, showcase events, facilitate registrations, display team members, and foster a vibrant tech community among IT students.',
    solution: 'Developed a full-featured student association website for ITSA (Information Technology Student Association) featuring event management system with VAJRA festival showcase, online registrations for cultural/technical/sports events, team member profiles with social links, contact forms, and responsive design to engage students across all devices.',
    results: [
      'Complete event management system',
      '12+ events organized (Cultural, Technical, Sports, T&P)',
      'Online registration & payment integration',
      'Team showcase with 17+ committee members',
      'Event categories with real-time updates',
      'Integrated contact forms & social media'
    ],
    techStack: ['React', 'Tailwind CSS', 'Framer Motion', 'Google Forms API', 'Responsive Design'],
    liveLink: 'https://itsa.ioit.acm.org/',
    icon: '🎓',
    gradient: 'from-teal-500/20 to-cyan-500/20'
  },
  {
    title: 'Haircut Salon - Professional Salon Website',
    category: 'Web Solution',
    image: haircutImg,
    problem: 'A professional hair salon needed an elegant, modern website to showcase their services, attract new clients, enable online bookings, and establish a strong digital presence in the competitive beauty industry.',
    solution: 'Designed and developed a sophisticated salon website featuring service catalogs for men and women, pricing information, online booking integration, FAQs section, contact forms, and responsive design with smooth animations to create an engaging user experience.',
    results: [
      'Professional service showcase',
      'Online booking system integration',
      'Separate pricing for men & women services',
      'Mobile-responsive design',
      'Contact forms & location information',
      'FAQs and terms & conditions'
    ],
    techStack: ['HTML5', 'CSS3', 'JavaScript', 'Bootstrap', 'Responsive Design'],
    liveLink: 'https://haircutsalon.netlify.app/',
    icon: '💇',
    gradient: 'from-pink-500/20 to-purple-500/20'
  }
];

// Ready-Made Projects for Sale
export const readyMadeProjects = [
  {
    title: 'E-Commerce Starter Kit',
    description: 'Complete online store solution with product management, shopping cart, payment integration, and admin dashboard.',
    businessType: 'Retail businesses, online stores, digital product sellers',
    features: [
      'Product catalog with categories',
      'Shopping cart & checkout',
      'Stripe & PayPal integration',
      'Admin dashboard',
      'Order management',
      'Customer accounts',
      'Responsive design',
      'SEO optimized'
    ],
    techStack: ['Next.js', 'Node.js', 'MongoDB', 'Stripe'],
    price: '2,999',
    cta: 'Buy & Customize',
    icon: '🛍️',
    gradient: 'from-svnate-teal/30 to-blue-500/30'
  },
  {
    title: 'SaaS Boilerplate',
    description: 'Production-ready SaaS template with authentication, subscription billing, user management, and analytics.',
    businessType: 'SaaS startups, B2B software companies, subscription services',
    features: [
      'User authentication & authorization',
      'Subscription billing (Stripe)',
      'Multi-tenancy support',
      'Admin & user dashboards',
      'Email notifications',
      'Analytics integration',
      'API ready',
      'Documentation included'
    ],
    techStack: ['React', 'Node.js', 'PostgreSQL', 'Stripe'],
    price: '3,999',
    cta: 'Request Access',
    icon: '🚀',
    gradient: 'from-purple-500/30 to-pink-500/30'
  },
  {
    title: 'Restaurant Management System',
    description: 'All-in-one solution for restaurants with table management, online ordering, kitchen display, and inventory.',
    businessType: 'Restaurants, cafes, food delivery businesses',
    features: [
      'Table reservation system',
      'Online ordering portal',
      'Kitchen display system',
      'Inventory management',
      'Staff management',
      'Menu builder',
      'POS integration ready',
      'Multi-location support'
    ],
    techStack: ['React', 'Express', 'MongoDB', 'Socket.io'],
    price: '4,499',
    cta: 'Buy & Customize',
    icon: '🍕',
    gradient: 'from-orange-500/30 to-red-500/30'
  },
  {
    title: 'Learning Management System',
    description: 'Complete LMS with course creation, student management, assessments, and progress tracking.',
    businessType: 'Educational institutions, online course creators, corporate training',
    features: [
      'Course builder',
      'Video streaming',
      'Quizzes & assessments',
      'Student progress tracking',
      'Certificates generation',
      'Discussion forums',
      'Payment integration',
      'Mobile responsive'
    ],
    techStack: ['Next.js', 'Node.js', 'PostgreSQL', 'AWS S3'],
    price: '3,499',
    cta: 'Request Access',
    icon: '📚',
    gradient: 'from-green-500/30 to-teal-500/30'
  },
  {
    title: 'CRM & Sales Pipeline',
    description: 'Customer relationship management system with lead tracking, sales pipeline, and automation.',
    businessType: 'Sales teams, B2B companies, service providers',
    features: [
      'Contact management',
      'Sales pipeline visualization',
      'Lead scoring',
      'Email automation',
      'Task & reminder system',
      'Reporting & analytics',
      'Integration APIs',
      'Mobile app included'
    ],
    techStack: ['React', 'Node.js', 'PostgreSQL', 'Redis'],
    price: '3,799',
    cta: 'Buy & Customize',
    icon: '📊',
    gradient: 'from-blue-500/30 to-indigo-500/30'
  },
  {
    title: 'Real Estate Portal',
    description: 'Property listing platform with advanced search, virtual tours, and lead management.',
    businessType: 'Real estate agencies, property managers, developers',
    features: [
      'Property listings',
      'Advanced search filters',
      '360° virtual tours',
      'Mortgage calculator',
      'Lead capture forms',
      'Agent profiles',
      'Map integration',
      'Mobile optimized'
    ],
    techStack: ['Next.js', 'Node.js', 'MongoDB', 'Google Maps'],
    price: '4,299',
    cta: 'Request Access',
    icon: '🏘️',
    gradient: 'from-svnate-blue/30 to-svnate-teal/30'
  }
];

// Services Data (legacy - kept for compatibility)
export const servicesData = [
  {
    title: 'Web Development',
    description: 'Custom web applications built with modern technologies and best practices.',
    icon: FaLaptopCode
  },
  {
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications for iOS and Android.',
    icon: FaMobileAlt
  },
  {
    title: 'Business Solutions',
    description: 'Automation tools and internal software to streamline operations.',
    icon: FaChartLine
  }
];

// Experience Data
export const experienceData = [
  {
    position: 'Senior Frontend Engineer',
    company: 'SVNATE',
    location: 'Remote',
    duration: '2023 - Present',
    description: 'Leading the frontend development team in building scalable and highly performant web applications. Architected the transition to a modern design system and established robust coding standards across multiple projects.',
    technologies: ['React', 'Next.js', 'Tailwind CSS', 'TypeScript']
  },
  {
    position: 'Full Stack Developer',
    company: 'Tech Solutions Inc.',
    location: 'New York, NY',
    duration: '2020 - 2023',
    description: 'Developed and maintained various client projects ranging from e-commerce platforms to enterprise SaaS applications. Implemented complex backend logic and integrated third-party APIs for seamless functionality.',
    technologies: ['Node.js', 'Express', 'MongoDB', 'React']
  },
  {
    position: 'UI/UX Developer',
    company: 'Creative Agency',
    location: 'London, UK',
    duration: '2018 - 2020',
    description: 'Bridged the gap between design and engineering. Created pixel-perfect, accessible, and responsive user interfaces based on high-fidelity Figma mockups. Animated complex SVG graphics and improved core web vitals.',
    technologies: ['JavaScript', 'SASS', 'Framer Motion', 'Figma']
  }
];
